/**
 * converts a string to HTML element
 *
 * @param {string} str
 * @returns {Node}
 */
export const toHtmlElement = (str) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = str;
  return wrapper.firstChild;
};
